import { Component, type ErrorInfo, type ReactNode } from 'react';
import { colors } from '../uikit/theme/theme';

interface AppErrorBoundaryProps {
  children: ReactNode;
}

interface AppErrorBoundaryState {
  hasError: boolean;
}

export class AppErrorBoundary extends Component<AppErrorBoundaryProps, AppErrorBoundaryState> {
  public state: AppErrorBoundaryState = {
    hasError: false,
  };

  public static getDerivedStateFromError(): AppErrorBoundaryState {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error('Unhandled UI error:', error, errorInfo);
  }

  public render(): ReactNode {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            gap: 12,
            padding: 24,
            fontFamily: 'sans-serif',
          }}
        >
          <p style={{ margin: 0, color: colors.text.secondary, fontSize: 14 }}>
            Произошла непредвиденная ошибка интерфейса.
          </p>
          <div style={{ display: 'flex', gap: 8 }}>
            <button
              type="button"
              onClick={() => window.location.reload()}
              style={{ padding: '8px 14px', cursor: 'pointer' }}
            >
              Перезагрузить страницу
            </button>
            <button
              type="button"
              onClick={() => {
                window.location.href = '/';
              }}
              style={{ padding: '8px 14px', cursor: 'pointer' }}
            >
              На главную
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
